export default __webpack_public_path__ + "static/5-78839a1c4f1067eb987b08b537d7f9cd.png";